import React from 'react';
import { Device } from '../generated/graphql';
import { formatDate } from './DateHelper';

/**
 * 端末が契約台数の枠を使っているかを、使用状況の列の表示にする。使用中は緑、未使用は灰色のラベルで出す。
 */
function getUsageLabel(isUsing: boolean): JSX.Element {
  if (isUsing) {
    return <span className="DeviceStatusPage-usage DeviceStatusPage-usage_using">使用中</span>;
  }
  return <span className="DeviceStatusPage-usage">未使用</span>;
}

export class DeviceListHelper {
  readonly effectiveDays: number;
  readonly quantity: number;
  readonly devices: Pick<Device, 'device_id' | 'last_login'>[] | undefined;

  constructor(
    effectiveDays: number,
    quantity: number,
    devices: Pick<Device, 'device_id' | 'last_login'>[] | undefined
  ) {
    this.effectiveDays = effectiveDays;
    this.quantity = quantity;
    this.devices = devices;
  }

  getDevices() {
    const usingThreshold =
      new Date().getTime() - this.effectiveDays * 24 * 60 * 60 * 1000;

    const devices = this.devices?.map((d, i) => {
      const date = new Date(d.last_login);
      return {
        date,
        deviceId: d.device_id,
      };
    });
    if (devices) {
      return devices
        .sort((a, b) => b.date.getTime() - a.date.getTime())
        .map((d, i) => {
          const isUsing =
            d.date.getTime() > usingThreshold && this.quantity > i;
          return {
            ...d,
            isUsing,
          };
        });
    }
    return [];
  }

  getUsingDeviceCount() {
    return this.getDevices().filter((_) => _.isUsing).length;
  }

  getElementArray() {
    return this.getDevices()
      .sort((a, b) => b.date.getTime() - a.date.getTime())
      .map((d) => {
        return (
          <tr key={d.deviceId}>
            <td className="DeviceStatusPage-device_id" title={d.deviceId}>
              {d.deviceId}
            </td>
            <td>{formatDate(d.date)}</td>
            <td>{getUsageLabel(d.isUsing)}</td>
          </tr>
        );
      });
  }
}
